import { AlertColor } from '@mui/material';
import { ActionType, createAction } from 'typesafe-actions';

export const showNotificationAction = createAction('@notifications/SHOW_NOTIFICATION')<{
  intlId: string;
  severity?: AlertColor;
}>();

export const clearNotificationAction = createAction('@notifications/CLEAR_NOTIFICATION')();

export type NotificationsActions =
  | ActionType<typeof showNotificationAction>
  | ActionType<typeof clearNotificationAction>;
